export default "__VITE_ASSET__7992b682__"